// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__xJBt-","inner":"Footer_inner__1pvqO"};